module.exports = __webpack_public_path__ + "static/monetize-f1c393cd6aca718ddbcba6b4c685e29b.png";